import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ShopProductState } from './biz-shop-product.reducer';
import { AppState } from '../app.state';

// Feature selector for the ProductState
export const selectProductState = createFeatureSelector<AppState, ShopProductState>('bizShopProducts');



// Selector for biz products
export const selectBizShopProducts = createSelector(
  selectProductState,
  (state: ShopProductState) => state.bizShopProducts
);

// Selector for loading state
export const selectBizShopProductsLoading = createSelector(
  selectProductState,
  (state: ShopProductState) => state.loading
);

// Selector for error state
export const selectBizShopError = createSelector(
  selectProductState,
  (state: ShopProductState) => state.error
);
